import { useAtom } from 'jotai';
import { NextRouter, useRouter } from 'next/router';
import { useEffect } from 'react';
import { appRouterAtom } from '../appRouter.atoms';

// This hook store the NextRouter in an atom so it can be to derived atoms
export default function useAppRouter(): NextRouter {
	const router = useRouter();
	const [appRouter, setAppRouter] = useAtom(appRouterAtom);

	useEffect(() => {
		setAppRouter(router);
	}, [router, setAppRouter]);

	return appRouter;
}
